/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MarketStatus from './MarketStatus';
import NftLevelUpInfoData from './NftLevelUpInfoData';

/**
 * The LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData model module.
 * @module model/LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData
 * @version 1.0
 */
class LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData {
    /**
     * Constructs a new <code>LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData</code>.
     * @alias module:model/LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData
     */
    constructor() { 
        
        LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData} The populated <code>LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData();

            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('nftKey')) {
                obj['nftKey'] = ApiClient.convertToType(data['nftKey'], 'String');
            }
            if (data.hasOwnProperty('nftType')) {
                obj['nftType'] = ApiClient.convertToType(data['nftType'], 'Number');
            }
            if (data.hasOwnProperty('nftGrade')) {
                obj['nftGrade'] = ApiClient.convertToType(data['nftGrade'], 'Number');
            }
            if (data.hasOwnProperty('baseSpeed')) {
                obj['baseSpeed'] = ApiClient.convertToType(data['baseSpeed'], 'Number');
            }
            if (data.hasOwnProperty('baseLuck')) {
                obj['baseLuck'] = ApiClient.convertToType(data['baseLuck'], 'Number');
            }
            if (data.hasOwnProperty('baseEnergy')) {
                obj['baseEnergy'] = ApiClient.convertToType(data['baseEnergy'], 'Number');
            }
            if (data.hasOwnProperty('baseDurability')) {
                obj['baseDurability'] = ApiClient.convertToType(data['baseDurability'], 'Number');
            }
            if (data.hasOwnProperty('sigil')) {
                obj['sigil'] = ApiClient.convertToType(data['sigil'], 'String');
            }
            if (data.hasOwnProperty('gemSocketColors')) {
                obj['gemSocketColors'] = ApiClient.convertToType(data['gemSocketColors'], 'String');
            }
            if (data.hasOwnProperty('plusFlag')) {
                obj['plusFlag'] = ApiClient.convertToType(data['plusFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('imageUrl')) {
                obj['imageUrl'] = ApiClient.convertToType(data['imageUrl'], 'String');
            }
            if (data.hasOwnProperty('minted')) {
                obj['minted'] = ApiClient.convertToType(data['minted'], 'Boolean');
            }
            if (data.hasOwnProperty('imageKey')) {
                obj['imageKey'] = ApiClient.convertToType(data['imageKey'], 'String');
            }
            if (data.hasOwnProperty('revealed')) {
                obj['revealed'] = ApiClient.convertToType(data['revealed'], 'Boolean');
            }
            if (data.hasOwnProperty('revealableAt')) {
                obj['revealableAt'] = ApiClient.convertToType(data['revealableAt'], 'Date');
            }
            if (data.hasOwnProperty('revealedAt')) {
                obj['revealedAt'] = ApiClient.convertToType(data['revealedAt'], 'Date');
            }
            if (data.hasOwnProperty('boxType')) {
                obj['boxType'] = ApiClient.convertToType(data['boxType'], 'Number');
            }
            if (data.hasOwnProperty('boxRarity')) {
                obj['boxRarity'] = ApiClient.convertToType(data['boxRarity'], 'Number');
            }
            if (data.hasOwnProperty('boxBlessedFlag')) {
                obj['boxBlessedFlag'] = ApiClient.convertToType(data['boxBlessedFlag'], 'Boolean');
            }
            if (data.hasOwnProperty('boxImageUrl')) {
                obj['boxImageUrl'] = ApiClient.convertToType(data['boxImageUrl'], 'String');
            }
            if (data.hasOwnProperty('lparentNftUid')) {
                obj['lparentNftUid'] = ApiClient.convertToType(data['lparentNftUid'], 'Number');
            }
            if (data.hasOwnProperty('rparentNftUid')) {
                obj['rparentNftUid'] = ApiClient.convertToType(data['rparentNftUid'], 'Number');
            }
            if (data.hasOwnProperty('metadataUrl')) {
                obj['metadataUrl'] = ApiClient.convertToType(data['metadataUrl'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('burnedAt')) {
                obj['burnedAt'] = ApiClient.convertToType(data['burnedAt'], 'Date');
            }
            if (data.hasOwnProperty('valid')) {
                obj['valid'] = ApiClient.convertToType(data['valid'], 'Boolean');
            }
            if (data.hasOwnProperty('extraStatsPoint')) {
                obj['extraStatsPoint'] = ApiClient.convertToType(data['extraStatsPoint'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsSpeed')) {
                obj['extraStatsSpeed'] = ApiClient.convertToType(data['extraStatsSpeed'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsLucky')) {
                obj['extraStatsLucky'] = ApiClient.convertToType(data['extraStatsLucky'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsEnergy')) {
                obj['extraStatsEnergy'] = ApiClient.convertToType(data['extraStatsEnergy'], 'Number');
            }
            if (data.hasOwnProperty('extraStatsDurability')) {
                obj['extraStatsDurability'] = ApiClient.convertToType(data['extraStatsDurability'], 'Number');
            }
            if (data.hasOwnProperty('extraSpeed')) {
                obj['extraSpeed'] = ApiClient.convertToType(data['extraSpeed'], 'Number');
            }
            if (data.hasOwnProperty('extraLuck')) {
                obj['extraLuck'] = ApiClient.convertToType(data['extraLuck'], 'Number');
            }
            if (data.hasOwnProperty('extraEnergy')) {
                obj['extraEnergy'] = ApiClient.convertToType(data['extraEnergy'], 'Number');
            }
            if (data.hasOwnProperty('extraDurability')) {
                obj['extraDurability'] = ApiClient.convertToType(data['extraDurability'], 'Number');
            }
            if (data.hasOwnProperty('condition')) {
                obj['condition'] = ApiClient.convertToType(data['condition'], 'Number');
            }
            if (data.hasOwnProperty('mileage')) {
                obj['mileage'] = ApiClient.convertToType(data['mileage'], 'Number');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('mintingCount')) {
                obj['mintingCount'] = ApiClient.convertToType(data['mintingCount'], 'Number');
            }
            if (data.hasOwnProperty('genesisMintingCount')) {
                obj['genesisMintingCount'] = ApiClient.convertToType(data['genesisMintingCount'], 'Number');
            }
            if (data.hasOwnProperty('gemSockets')) {
                obj['gemSockets'] = ApiClient.convertToType(data['gemSockets'], 'String');
            }
            if (data.hasOwnProperty('engineSocket')) {
                obj['engineSocket'] = ApiClient.convertToType(data['engineSocket'], 'Number');
            }
            if (data.hasOwnProperty('updateAt')) {
                obj['updateAt'] = ApiClient.convertToType(data['updateAt'], 'Date');
            }
            if (data.hasOwnProperty('lastImportedAt')) {
                obj['lastImportedAt'] = ApiClient.convertToType(data['lastImportedAt'], 'Date');
            }
            if (data.hasOwnProperty('expiredAt')) {
                obj['expiredAt'] = ApiClient.convertToType(data['expiredAt'], 'Date');
            }
            if (data.hasOwnProperty('nftLevelUpInfo')) {
                obj['nftLevelUpInfo'] = NftLevelUpInfoData.constructFromObject(data['nftLevelUpInfo']);
            }
            if (data.hasOwnProperty('storedPower')) {
                obj['storedPower'] = ApiClient.convertToType(data['storedPower'], 'Number');
            }
            if (data.hasOwnProperty('addedMaxStoredPower')) {
                obj['addedMaxStoredPower'] = ApiClient.convertToType(data['addedMaxStoredPower'], 'Number');
            }
            if (data.hasOwnProperty('addedMaxStoredPowerEndAt')) {
                obj['addedMaxStoredPowerEndAt'] = ApiClient.convertToType(data['addedMaxStoredPowerEndAt'], 'Date');
            }
            if (data.hasOwnProperty('speed')) {
                obj['speed'] = ApiClient.convertToType(data['speed'], 'Number');
            }
            if (data.hasOwnProperty('luck')) {
                obj['luck'] = ApiClient.convertToType(data['luck'], 'Number');
            }
            if (data.hasOwnProperty('energy')) {
                obj['energy'] = ApiClient.convertToType(data['energy'], 'Number');
            }
            if (data.hasOwnProperty('durability')) {
                obj['durability'] = ApiClient.convertToType(data['durability'], 'Number');
            }
            if (data.hasOwnProperty('listingNo')) {
                obj['listingNo'] = ApiClient.convertToType(data['listingNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('pricePer')) {
                obj['pricePer'] = ApiClient.convertToType(data['pricePer'], 'Number');
            }
            if (data.hasOwnProperty('pricePerString')) {
                obj['pricePerString'] = ApiClient.convertToType(data['pricePerString'], 'String');
            }
            if (data.hasOwnProperty('priceHvh')) {
                obj['priceHvh'] = ApiClient.convertToType(data['priceHvh'], 'Number');
            }
            if (data.hasOwnProperty('priceHvhString')) {
                obj['priceHvhString'] = ApiClient.convertToType(data['priceHvhString'], 'String');
            }
            if (data.hasOwnProperty('priceUsdt')) {
                obj['priceUsdt'] = ApiClient.convertToType(data['priceUsdt'], 'Number');
            }
            if (data.hasOwnProperty('priceUsdtString')) {
                obj['priceUsdtString'] = ApiClient.convertToType(data['priceUsdtString'], 'String');
            }
            if (data.hasOwnProperty('priceArb')) {
                obj['priceArb'] = ApiClient.convertToType(data['priceArb'], 'Number');
            }
            if (data.hasOwnProperty('priceArbString')) {
                obj['priceArbString'] = ApiClient.convertToType(data['priceArbString'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = MarketStatus.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('registedAt')) {
                obj['registedAt'] = ApiClient.convertToType(data['registedAt'], 'Date');
            }
            if (data.hasOwnProperty('sellerEmail')) {
                obj['sellerEmail'] = ApiClient.convertToType(data['sellerEmail'], 'String');
            }
            if (data.hasOwnProperty('sellerAccountNo')) {
                obj['sellerAccountNo'] = ApiClient.convertToType(data['sellerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('buyerEmail')) {
                obj['buyerEmail'] = ApiClient.convertToType(data['buyerEmail'], 'String');
            }
            if (data.hasOwnProperty('buyerAccountNo')) {
                obj['buyerAccountNo'] = ApiClient.convertToType(data['buyerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('transactedAt')) {
                obj['transactedAt'] = ApiClient.convertToType(data['transactedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['nftKey'] && !(typeof data['nftKey'] === 'string' || data['nftKey'] instanceof String)) {
            throw new Error("Expected the field `nftKey` to be a primitive type in the JSON string but got " + data['nftKey']);
        }
        // ensure the json data is a string
        if (data['sigil'] && !(typeof data['sigil'] === 'string' || data['sigil'] instanceof String)) {
            throw new Error("Expected the field `sigil` to be a primitive type in the JSON string but got " + data['sigil']);
        }
        // ensure the json data is a string
        if (data['gemSocketColors'] && !(typeof data['gemSocketColors'] === 'string' || data['gemSocketColors'] instanceof String)) {
            throw new Error("Expected the field `gemSocketColors` to be a primitive type in the JSON string but got " + data['gemSocketColors']);
        }
        // ensure the json data is a string
        if (data['imageUrl'] && !(typeof data['imageUrl'] === 'string' || data['imageUrl'] instanceof String)) {
            throw new Error("Expected the field `imageUrl` to be a primitive type in the JSON string but got " + data['imageUrl']);
        }
        // ensure the json data is a string
        if (data['imageKey'] && !(typeof data['imageKey'] === 'string' || data['imageKey'] instanceof String)) {
            throw new Error("Expected the field `imageKey` to be a primitive type in the JSON string but got " + data['imageKey']);
        }
        // ensure the json data is a string
        if (data['boxImageUrl'] && !(typeof data['boxImageUrl'] === 'string' || data['boxImageUrl'] instanceof String)) {
            throw new Error("Expected the field `boxImageUrl` to be a primitive type in the JSON string but got " + data['boxImageUrl']);
        }
        // ensure the json data is a string
        if (data['metadataUrl'] && !(typeof data['metadataUrl'] === 'string' || data['metadataUrl'] instanceof String)) {
            throw new Error("Expected the field `metadataUrl` to be a primitive type in the JSON string but got " + data['metadataUrl']);
        }
        // ensure the json data is a string
        if (data['gemSockets'] && !(typeof data['gemSockets'] === 'string' || data['gemSockets'] instanceof String)) {
            throw new Error("Expected the field `gemSockets` to be a primitive type in the JSON string but got " + data['gemSockets']);
        }
        // validate the optional field `nftLevelUpInfo`
        if (data['nftLevelUpInfo']) { // data not null
          NftLevelUpInfoData.validateJSON(data['nftLevelUpInfo']);
        }
        // ensure the json data is a string
        if (data['pricePerString'] && !(typeof data['pricePerString'] === 'string' || data['pricePerString'] instanceof String)) {
            throw new Error("Expected the field `pricePerString` to be a primitive type in the JSON string but got " + data['pricePerString']);
        }
        // ensure the json data is a string
        if (data['priceHvhString'] && !(typeof data['priceHvhString'] === 'string' || data['priceHvhString'] instanceof String)) {
            throw new Error("Expected the field `priceHvhString` to be a primitive type in the JSON string but got " + data['priceHvhString']);
        }
        // ensure the json data is a string
        if (data['priceUsdtString'] && !(typeof data['priceUsdtString'] === 'string' || data['priceUsdtString'] instanceof String)) {
            throw new Error("Expected the field `priceUsdtString` to be a primitive type in the JSON string but got " + data['priceUsdtString']);
        }
        // ensure the json data is a string
        if (data['priceArbString'] && !(typeof data['priceArbString'] === 'string' || data['priceArbString'] instanceof String)) {
            throw new Error("Expected the field `priceArbString` to be a primitive type in the JSON string but got " + data['priceArbString']);
        }
        // ensure the json data is a string
        if (data['sellerEmail'] && !(typeof data['sellerEmail'] === 'string' || data['sellerEmail'] instanceof String)) {
            throw new Error("Expected the field `sellerEmail` to be a primitive type in the JSON string but got " + data['sellerEmail']);
        }
        // ensure the json data is a string
        if (data['buyerEmail'] && !(typeof data['buyerEmail'] === 'string' || data['buyerEmail'] instanceof String)) {
            throw new Error("Expected the field `buyerEmail` to be a primitive type in the JSON string but got " + data['buyerEmail']);
        }

        return true;
    }


}



/**
 * @member {Number} nftUid
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['nftUid'] = undefined;

/**
 * @member {String} nftKey
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['nftKey'] = undefined;

/**
 * @member {Number} nftType
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['nftType'] = undefined;

/**
 * @member {Number} nftGrade
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['nftGrade'] = undefined;

/**
 * @member {Number} baseSpeed
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['baseSpeed'] = undefined;

/**
 * @member {Number} baseLuck
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['baseLuck'] = undefined;

/**
 * @member {Number} baseEnergy
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['baseEnergy'] = undefined;

/**
 * @member {Number} baseDurability
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['baseDurability'] = undefined;

/**
 * @member {String} sigil
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['sigil'] = undefined;

/**
 * @member {String} gemSocketColors
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['gemSocketColors'] = undefined;

/**
 * @member {Boolean} plusFlag
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['plusFlag'] = undefined;

/**
 * @member {String} imageUrl
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['imageUrl'] = undefined;

/**
 * @member {Boolean} minted
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['minted'] = undefined;

/**
 * @member {String} imageKey
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['imageKey'] = undefined;

/**
 * @member {Boolean} revealed
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['revealed'] = undefined;

/**
 * @member {Date} revealableAt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['revealableAt'] = undefined;

/**
 * @member {Date} revealedAt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['revealedAt'] = undefined;

/**
 * @member {Number} boxType
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['boxType'] = undefined;

/**
 * @member {Number} boxRarity
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['boxRarity'] = undefined;

/**
 * @member {Boolean} boxBlessedFlag
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['boxBlessedFlag'] = undefined;

/**
 * @member {String} boxImageUrl
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['boxImageUrl'] = undefined;

/**
 * @member {Number} lparentNftUid
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['lparentNftUid'] = undefined;

/**
 * @member {Number} rparentNftUid
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['rparentNftUid'] = undefined;

/**
 * @member {String} metadataUrl
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['metadataUrl'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['createdAt'] = undefined;

/**
 * @member {Date} burnedAt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['burnedAt'] = undefined;

/**
 * @member {Boolean} valid
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['valid'] = undefined;

/**
 * @member {Number} extraStatsPoint
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['extraStatsPoint'] = undefined;

/**
 * @member {Number} extraStatsSpeed
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['extraStatsSpeed'] = undefined;

/**
 * @member {Number} extraStatsLucky
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['extraStatsLucky'] = undefined;

/**
 * @member {Number} extraStatsEnergy
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['extraStatsEnergy'] = undefined;

/**
 * @member {Number} extraStatsDurability
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['extraStatsDurability'] = undefined;

/**
 * @member {Number} extraSpeed
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['extraSpeed'] = undefined;

/**
 * @member {Number} extraLuck
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['extraLuck'] = undefined;

/**
 * @member {Number} extraEnergy
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['extraEnergy'] = undefined;

/**
 * @member {Number} extraDurability
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['extraDurability'] = undefined;

/**
 * @member {Number} condition
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['condition'] = undefined;

/**
 * @member {Number} mileage
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['mileage'] = undefined;

/**
 * @member {Number} level
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['level'] = undefined;

/**
 * @member {Number} mintingCount
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['mintingCount'] = undefined;

/**
 * @member {Number} genesisMintingCount
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['genesisMintingCount'] = undefined;

/**
 * @member {String} gemSockets
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['gemSockets'] = undefined;

/**
 * @member {Number} engineSocket
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['engineSocket'] = undefined;

/**
 * @member {Date} updateAt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['updateAt'] = undefined;

/**
 * @member {Date} lastImportedAt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['lastImportedAt'] = undefined;

/**
 * @member {Date} expiredAt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['expiredAt'] = undefined;

/**
 * @member {module:model/NftLevelUpInfoData} nftLevelUpInfo
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['nftLevelUpInfo'] = undefined;

/**
 * @member {Number} storedPower
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['storedPower'] = undefined;

/**
 * @member {Number} addedMaxStoredPower
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['addedMaxStoredPower'] = undefined;

/**
 * @member {Date} addedMaxStoredPowerEndAt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['addedMaxStoredPowerEndAt'] = undefined;

/**
 * @member {Number} speed
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['speed'] = undefined;

/**
 * @member {Number} luck
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['luck'] = undefined;

/**
 * @member {Number} energy
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['energy'] = undefined;

/**
 * @member {Number} durability
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['durability'] = undefined;

/**
 * @member {Number} listingNo
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['listingNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['accountNo'] = undefined;

/**
 * @member {Number} pricePer
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['pricePer'] = undefined;

/**
 * @member {String} pricePerString
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['pricePerString'] = undefined;

/**
 * @member {Number} priceHvh
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['priceHvh'] = undefined;

/**
 * @member {String} priceHvhString
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['priceHvhString'] = undefined;

/**
 * @member {Number} priceUsdt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['priceUsdt'] = undefined;

/**
 * @member {String} priceUsdtString
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['priceUsdtString'] = undefined;

/**
 * @member {Number} priceArb
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['priceArb'] = undefined;

/**
 * @member {String} priceArbString
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['priceArbString'] = undefined;

/**
 * @member {module:model/MarketStatus} status
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['status'] = undefined;

/**
 * @member {Date} registedAt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['registedAt'] = undefined;

/**
 * @member {String} sellerEmail
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['sellerEmail'] = undefined;

/**
 * @member {Number} sellerAccountNo
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['sellerAccountNo'] = undefined;

/**
 * @member {String} buyerEmail
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['buyerEmail'] = undefined;

/**
 * @member {Number} buyerAccountNo
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['buyerAccountNo'] = undefined;

/**
 * @member {Date} transactedAt
 */
LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData.prototype['transactedAt'] = undefined;






export default LogControllerDtoMarketCarTransactionLogListMarketCarTransactionLogData;

